import React, { useState, forwardRef } from "react";
import { cn } from "../../lib/utils";

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  className?: string;
  checkboxClassName?: string;
  labelClassName?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, className, checkboxClassName, labelClassName, checked: controlledChecked, onChange, ...props }, ref) => {
    const [internalChecked, setInternalChecked] = useState(false);
    
    // Determine if it's controlled or uncontrolled
    const isControlled = controlledChecked !== undefined;
    const isChecked = isControlled ? controlledChecked : internalChecked;
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!isControlled) {
        setInternalChecked(e.target.checked);
      }
      onChange?.(e);
    };

    return (
      <div className={cn("flex items-start gap-2", className)}>
        <label className="relative flex items-center cursor-pointer select-none">
          <input
            type="checkbox"
            ref={ref}
            checked={isChecked}
            onChange={handleChange}
            {...props}
            className="absolute opacity-0 w-4 h-4 cursor-pointer"
            style={{ left: 0, top: 0 }}
          />
          <span
            className={cn(
              "w-4 h-4 border rounded flex items-center justify-center transition-colors",
              isChecked ? "bg-[#daed6e] border-[#daed6e]" : "bg-white border-[#E7E7E7]",
              checkboxClassName
            )}
            aria-hidden="true"
          >
            {isChecked && (
              <svg 
                width="10" 
                height="10" 
                viewBox="0 0 10 10" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  d="M8.5 3L4 7.5L1.5 5" 
                  stroke="black" 
                  strokeWidth="1.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </span>
        </label>
        {label && (
          <label className={cn("text-sm text-black opacity-80 leading-tight cursor-pointer", labelClassName)}>
            {label}
          </label>
        )}
      </div>
    );
  }
);

Checkbox.displayName = "Checkbox"; 